module.exports = __webpack_public_path__ + "static/media/holiday.65397d88.svg";